import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface IHorizonScanState {
	actionPlanTabIndex: string;
	currentWorkflowStatus: string;
	shouldHorizonDetailRefresh: boolean;
	checkedItems: { [key: string]: boolean };
	selectedCategories: { [key: string]: boolean | string[] };
	horizonLandingSearchText: string;
	horizonDrawerState: boolean;
	horizonFilters: any;
	horizonfilterKeys: any;
	horizonApplyFilterEnabled: boolean;
	horizonAppliedfilterKeys: any;
	horizonSelectedAppliedfilterKeys: any;
	horizonScanSourceFiltersKey: string;
	applyFilterFlag: boolean;
	showAssignedToMe: boolean;
	dueDateValueRange: any;
	effectiveDateValue: any;
	selectedDueDate: string;
	selectedEffectiveDate: string;
	selectedDateArray: string[];
	dueStartDate: Date | null;
	dueEndDate: Date | null;
	effectiveStartDate: Date | null;
	effectiveEndDate: Date | null;
	isNavigateToDetails: boolean;
	isAISummaryRegenerated: boolean;
}

const initialState: IHorizonScanState = {
	actionPlanTabIndex: 'mapping',
	currentWorkflowStatus: 'Not Started',
	shouldHorizonDetailRefresh: false,
	checkedItems: {},
	selectedCategories: {},
	horizonLandingSearchText: '',
	horizonDrawerState: false,
	horizonFilters: [],
	horizonApplyFilterEnabled: false,
	horizonAppliedfilterKeys: [],
	horizonSelectedAppliedfilterKeys: [],
	horizonScanSourceFiltersKey: '',
	applyFilterFlag: false,
	horizonfilterKeys: [],
	showAssignedToMe: false,
	dueDateValueRange: '',
	effectiveDateValue: '',
	selectedDueDate: '',
	selectedEffectiveDate: '',
	selectedDateArray: [],
	dueStartDate: null,
	dueEndDate: null,
	effectiveStartDate: null,
	effectiveEndDate: null,
	isNavigateToDetails: false,
	isAISummaryRegenerated: false,
};

export const horizonScanSlice = createSlice({
	name: 'horizonScan',
	initialState,
	reducers: {
		setActionPlanTabIndex(state, action: PayloadAction<string>) {
			state.actionPlanTabIndex = action.payload;
		},
		setCurrentWorkflowStatus: (state, action: PayloadAction<string>) => {
			state.currentWorkflowStatus = action.payload;
		},
		setShouldHorizonDetailRefresh: (state, action: PayloadAction<boolean>) => {
			state.shouldHorizonDetailRefresh = action.payload;
		},
		setCheckedItems(state, action: PayloadAction<{ [key: string]: boolean }>) {
			state.checkedItems = action.payload;
		},
		setSelectedCategory(
			state,
			action: PayloadAction<{ [key: string]: boolean }>,
		) {
			state.selectedCategories = action.payload;
		},
		setHorizonLandingSearchText: (state, action: PayloadAction<string>) => {
			state.horizonLandingSearchText = action.payload;
		},
		setHorizonDrawerState: (state, action: PayloadAction<boolean>) => {
			state.horizonDrawerState = action.payload;
		},
		setHorizonFilter: (state, action: PayloadAction<any[]>) => {
			state.horizonFilters = action.payload;
		},
		setHorizonApplyFilterEnabled: (state, action: PayloadAction<boolean>) => {
			state.horizonApplyFilterEnabled = action.payload;
		},
		setHorizonAppliedFilterList: (state, action: PayloadAction<any>) => {
			state.horizonAppliedfilterKeys = action.payload;
		},
		setHorizonSelectedAppliedFilterList: (
			state,
			action: PayloadAction<any>,
		) => {
			state.horizonSelectedAppliedfilterKeys = action.payload;
		},
		setRiskRefTaxonomySourceFiltersKey: (
			state,
			action: PayloadAction<string>,
		) => {
			state.horizonScanSourceFiltersKey = action.payload;
		},
		setHorizonFilterFlag: (state, action: PayloadAction<boolean>) => {
			state.applyFilterFlag = action.payload;
		},
		setHorizonFilterKeys: (state, action: PayloadAction<any>) => {
			state.horizonfilterKeys = action.payload;
		},
		setShowAssignedToMe: (state, action: PayloadAction<boolean>) => {
			state.showAssignedToMe = action.payload;
		},
		setDueDateValue: (state, action: PayloadAction<any>) => {
			state.dueDateValueRange = action.payload;
		},
		setEffectiveDateValue: (state, action: PayloadAction<any>) => {
			state.effectiveDateValue = action.payload;
		},
		setSelectedDueDate: (state, action: PayloadAction<string>) => {
			state.selectedDueDate = action.payload;
		},
		setSelectedEffectiveDate: (state, action: PayloadAction<string>) => {
			state.selectedEffectiveDate = action.payload;
		},
		setSelectedDateArray: (state, action: PayloadAction<string[]>) => {
			state.selectedDateArray = action.payload;
		},
		setDueStartDate: (state, action: PayloadAction<Date | null>) => {
			state.dueStartDate = action.payload;
		},
		setDueEndDate: (state, action: PayloadAction<Date | null>) => {
			state.dueEndDate = action.payload;
		},
		setEffectiveStartDate: (state, action: PayloadAction<Date | null>) => {
			state.effectiveStartDate = action.payload;
		},
		setEffectiveEndDate: (state, action: PayloadAction<Date | null>) => {
			state.effectiveEndDate = action.payload;
		},
		setClearAllDates: (state) => {
			state.dueStartDate = initialState.dueStartDate;
			state.dueEndDate = initialState.dueEndDate;
			state.effectiveStartDate = initialState.effectiveStartDate;
			state.effectiveEndDate = initialState.effectiveEndDate;
		},
		setIsNavigateToDetails: (state, action: PayloadAction<boolean>) => {
			state.isNavigateToDetails = action.payload;
		},
		setIsAISummaryRegenerated: (state, action: PayloadAction<boolean>) => {
			state.isAISummaryRegenerated = action.payload;
		},
	},
});

export const {
	setActionPlanTabIndex,
	setCurrentWorkflowStatus,
	setShouldHorizonDetailRefresh,
	setCheckedItems,
	setSelectedCategory,
	setHorizonLandingSearchText,
	setHorizonDrawerState,
	setHorizonFilter,
	setHorizonApplyFilterEnabled,
	setHorizonAppliedFilterList,
	setHorizonSelectedAppliedFilterList,
	setHorizonFilterFlag,
	setHorizonFilterKeys,
	setShowAssignedToMe,
	setDueDateValue,
	setEffectiveDateValue,
	setSelectedDueDate,
	setSelectedEffectiveDate,
	setSelectedDateArray,
	setDueStartDate,
	setDueEndDate,
	setEffectiveStartDate,
	setEffectiveEndDate,
	setClearAllDates,
	setIsNavigateToDetails,
	setIsAISummaryRegenerated,
} = horizonScanSlice.actions;

export default horizonScanSlice.reducer;
